<template>
  <div class="table-responsive"> 
    <p> <b>Colegiatura:</b> {{getInscripcion.monto_colegiatura}} Bs </p>
    <table class="table table-condensed table-bordered">
      <thead>
        <tr>
          <th>Nro cuota</th>
          <th>ID</th>
          <th>Monto</th>
          <th>Saldo</th>
          <th>Fecha prevista</th>
          <th>Puede pagar</th>
          <th>Cancelado</th>
          <th>Pagar/Cancelar</th> 
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="ind" v-for="(p,ind) in getInscripcion.cuotas_por_pagar">
          <td> {{p.nro_cuota}} </td>
          <td> {{p.id}} </td>
          <td> {{p.monto}} </td>
          <td> {{p.saldo}} </td>
          <td> {{p.fecha}} </td>
          <td> {{p.puede_pagar?'SI':'NO'}} </td>
          <td> {{p.cancelado?'SI':'NO'}} </td>
          <td> 
            <div v-if="isAsesor">
              <button v-if="p.nro_cuota < 2" @click="beforePagarCuota(p)" data-toggle="modal" data-target="#modal-cuota" class="btn btn-sm btn-azul" :disabled="!p.puede_pagar">Registrar pago</button> 
              <p class="text-info" v-else>No Habilitado</p>
            </div>
            <div v-else>
              <button @click="beforePagarCuota(p)" data-toggle="modal" data-target="#modal-cuota" class="btn btn-sm btn-azul" :disabled="!p.puede_pagar">Registrar pago</button> 
            </div>
          </td>
        </tr>
      </tbody>
    </table>


 
    <div class="modal fade" tabindex="-1" role="dialog" id="modal-cuota">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
            <h4 class="modal-title text-center"> Registrar Pago de Cuota </h4>
          </div>
          <div class="modal-body"> <PagarCuota :cuota_pagar="cuota_pagar" :listener="listener"/> </div>
          <div class="modal-footer"> <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button> </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import PagarCuota from '@/components/AP.vue'
export default {
  props:{ 
    getInscripcion:{type:Object,required:true},
    listener:{type:Object,required:true},
    isAsesor:{type:Boolean,required:false,default:false} 
  },
  data(){
    return{
      cuota_pagar:{},
    }
  },
  components:{ PagarCuota },
  methods:{
    beforePagarCuota( cuo ){ 
      this.cuota_pagar=cuo; 
      this.cuota_pagar.idcuota = new Date().getTime();
    },
  }
}
</script>